import './scss/index.scss'
// import img from './images/logo_phimedia.svg'
import SmoothScroll from '../node_modules/smooth-scroll/src/js/smooth-scroll/smooth-scroll';

var blogRight = document.querySelector('.blog .right');
var slider = document.querySelector('.slider');
var btnLeft = document.querySelector('.btn-left');
var btnRight = document.querySelector('.btn-right');
var sliderCount = slider.children.length;
var sliderIndex = 1;
var isSliding = false;
var initialX = null;
var initialY = null;
// var movePosition = -43.6;

function getMovePosition() {
  if(document.documentElement.clientWidth > 900) {
    return -43.6;
  } else if(document.documentElement.clientWidth > 500) {
    return -51;
  } else {
    return -100;
  }
}

function btnLeftFunc() {
  if(!isSliding && sliderIndex > 1) {
    isSliding = true;
    sliderIndex--;
    // var movePosition = -43.6 * (sliderIndex - 1);
    slider.style = 'transform: translateX(' + getMovePosition() * (sliderIndex - 1) + '%); transition: transform 1s;';
    // slider.style = 'transform: translateX(' + movePosition + '%); transition: transform 1s;';
  }
  isSliding = false;
}
function btnRightFunc() {
  var theSliderCount = sliderCount;
  if(document.documentElement.clientWidth > 500) {
    theSliderCount--;
  }

  // if(!isSliding && sliderIndex < (sliderCount - 1)) {
  if(!isSliding && sliderIndex < theSliderCount) {
    isSliding = true;
    slider.style = 'transform: translateX(' + getMovePosition() * sliderIndex + '%); transition: transform 1s;';
    // slider.style = 'transform: translateX(' + movePosition + '%); transition: transform 1s;';
    sliderIndex++;
  }
  isSliding = false;
}

function startTouch(e) {
  initialX = e.touches[0].clientX;
  initialY = e.touches[0].clientY;
};
function moveTouch(e) {
  if (initialX === null) {
    return;
  }

  if (initialY === null) {
    return;
  }

  var currentX = e.touches[0].clientX;
  var currentY = e.touches[0].clientY;

  var diffX = initialX - currentX;
  var diffY = initialY - currentY;

  if (Math.abs(diffX) > Math.abs(diffY)) {
    // sliding horizontally
    if (diffX > 0) {
      // swiped left
      btnRightFunc();
      console.log("swiped left");
    } else {
      // swiped right
      btnLeftFunc();
      console.log("swiped right");
    }
    e.preventDefault();
  } else {
    // sliding vertically
    if (diffY > 0) {
      // swiped up
      console.log("swiped up");
    } else {
      // swiped down
      console.log("swiped down");
    }  
  }

  initialX = null;
  initialY = null;

  // e.preventDefault();
};

btnLeft.addEventListener('click', btnLeftFunc);
btnRight.addEventListener('click', btnRightFunc);
blogRight.addEventListener('touchstart', startTouch, false);
blogRight.addEventListener('touchmove', moveTouch, false);

var prjImg = document.querySelectorAll('.prjimg');
var prjImgIndex = 0;
var elseImg = Array.prototype.slice.call(document.querySelectorAll('.else-img'));
elseImg.unshift(document.querySelector('.top'));
var visiblePrjImg;

function checkIsVisible() {
  visiblePrjImg = new Array();

  for(var i = 0; i < elseImg.length; i++) {
    var elementTop = elseImg[i].getBoundingClientRect().top;
    console.log(i + ":" + elementTop);

    if(elementTop - window.innerHeight <= -10) {
      visiblePrjImg.push(prjImg[i]);
    }
  }
  loadProjectImage();
}

function loadProjectImage() {
  setTimeout(function() {
    if(prjImgIndex < visiblePrjImg.length) {
      visiblePrjImg[prjImgIndex].className = 'prjimgload';
      prjImgIndex++;
      loadProjectImage();
    }
    // if(prjImgIndex < prjImg.length) {
    //   prjImg[prjImgIndex].className = 'prjimgload';
    //   prjImgIndex++;
    //   loadProjectImage();
    // }
  }, 200)
}

window.addEventListener('load', function() {
  // var prjimg = document.querySelectorAll('.prjimg');
  // for(var i = 0; i < prjimg.length; i++) {
  //   prjimg[i].className = 'prjimgload';
  // }
  // loadProjectImage();
  checkIsVisible();
});
window.addEventListener('scroll', checkIsVisible);

var scroll = new SmoothScroll('a[href*="#"]');
// btnLeft.addEventListener('click', function() {
//   if(!isSliding && sliderIndex > 1) {
//     isSliding = true;
//     sliderIndex--;
//     // var movePosition = -43.6 * (sliderIndex - 1);
//     slider.style = 'transform: translateX(' + getMovePosition() * (sliderIndex - 1) + '%); transition: transform 1s;';
//     // slider.style = 'transform: translateX(' + movePosition + '%); transition: transform 1s;';
//   }
//   isSliding = false;
// });

// btnRight.addEventListener('click', function() {
//   var theSliderCount = sliderCount;
//   if(document.documentElement.clientWidth > 500) {
//     theSliderCount--;
//   }

//   // if(!isSliding && sliderIndex < (sliderCount - 1)) {
//   if(!isSliding && sliderIndex < theSliderCount) {
//     isSliding = true;
//     slider.style = 'transform: translateX(' + getMovePosition() * sliderIndex + '%); transition: transform 1s;';
//     // slider.style = 'transform: translateX(' + movePosition + '%); transition: transform 1s;';
//     sliderIndex++;
//   }
//   isSliding = false;
// });
